import PropTypes from "prop-types";
import React from "react";

import { getBootstrapData } from "@swa-ui/bootstrap";
import { Link, Text } from "@swa-ui/core";
import i18n from "@swa-ui/locale";
import { PlacementFactory } from "@swa-ui/placements";

import {
  AccessibilityAccommodationsFormFields,
  accessibilityAccommodationsFormFieldsPropTypes,
} from "./AccessibilityAccommodationsFormFields";
import {
  AllergiesFormFields,
  allergiesFormFieldsPropTypes,
} from "./AllergiesFormFields/AllergiesFormFields";
import {
  AnimalAssistanceFormField,
  animalAssistanceFormFieldsPropTypes,
} from "./AnimalAssistanceFormField";
import {
  MedicalEquipmentFormFields,
  medicalEquipmentFormFieldsPropTypes,
} from "./MedicalEquipmentFormFields";
import styles from "./PassengerAccommodationsFormFields.module.scss";
import {
  PersonalWheelchairAssistanceFormFields,
  personalWheelchairAssistanceFormFieldsPropTypes,
} from "./PersonalWheelchairAssistanceFormFields";
import {
  WheelchairAssistanceFormField,
  wheelchairAssistanceFormFieldPropTypes,
} from "./WheelchairAssistanceFormField";

export const PassengerAccommodationsFormFields = (props) => {
  const {
    accessibilityAccommodationsFormFieldsProps = {},
    allergiesFormFieldsProps = {},
    animalAssistanceFormFieldProps = {},
    medicalEquipmentFormFieldsProps = {},
    personalWheelchairAssistanceFormFieldsProps = {},
    wheelchairAssistanceFormFieldProps = {},
  } = props;
  const { HELP_CENTER_CONTACT_US } = getBootstrapData("urls");

  return (
    <div className={styles.container}>
      <PlacementFactory className={styles.disabilityOptionText} id="disabilityOptionText" />
      {renderFormFields()}
      {renderDisclaimer()}
    </div>
  );

  function renderFormFields() {
    return (
      <div className={styles.formFieldsWrapper}>
        <AccessibilityAccommodationsFormFields {...accessibilityAccommodationsFormFieldsProps} />
        <AnimalAssistanceFormField {...animalAssistanceFormFieldProps} />
        <WheelchairAssistanceFormField {...wheelchairAssistanceFormFieldProps} />
        <PersonalWheelchairAssistanceFormFields {...personalWheelchairAssistanceFormFieldsProps} />
        <AllergiesFormFields {...allergiesFormFieldsProps} />
        <MedicalEquipmentFormFields {...medicalEquipmentFormFieldsProps} />
      </div>
    );
  }

  function renderDisclaimer() {
    return (
      <Text className={styles.disclaimer} color="var(--disclaimer-text)">
        <Text bold element="span">
          {i18n("PassengerAccommodationsFormFields__NOTE")}
        </Text>{" "}
        {i18n("PassengerAccommodationsFormFields__DISCLAIMER")}
        <Link {...getHelpCenterLinkProps()}>
          {i18n("PassengerAccommodationsFormFields__HELP_CENTER")}
        </Link>
      </Text>
    );
  }

  function getHelpCenterLinkProps() {
    return {
      description: i18n("PersonalWheelchairAssistanceFormFields__HELP_CENTER"),
      href: HELP_CENTER_CONTACT_US,
      newWindow: true,
      size: "fontSize14",
      styleType: "link-inline",
    };
  }
};

PassengerAccommodationsFormFields.propTypes = {
  /** Props for accessibility accommodations component. */
  accessibilityAccommodationsFormFieldsProps: PropTypes.shape(
    accessibilityAccommodationsFormFieldsPropTypes
  ),

  /** Props for allergies form fields component. */
  allergiesFormFieldsProps: PropTypes.shape(allergiesFormFieldsPropTypes),

  /** Props for animal assistance component. */
  animalAssistanceFormFieldProps: PropTypes.shape(animalAssistanceFormFieldsPropTypes),

  /** Props for medical equipment assistance component. */
  medicalEquipmentFormFieldsProps: PropTypes.shape(medicalEquipmentFormFieldsPropTypes),

  /** Props for personal wheel chair assistance component. */
  personalWheelchairAssistanceFormFieldsProps: PropTypes.shape(
    personalWheelchairAssistanceFormFieldsPropTypes
  ),

  /** Props for wheel chair assistance component. */
  wheelchairAssistanceFormFieldProps: PropTypes.shape(wheelchairAssistanceFormFieldPropTypes),
};
